/**
 * @author Sunny Li（李丹）
 * @email sunnyli@mail.staritgp.com
 * @date 2018/8/13 20:10
 */
import { notification, Input } from 'antd'
import axios from 'axios'
import { useState, useEffect } from 'react'
import { ONLINE_SERVICE_PATH } from 'util/constants'
import apiErrorNotification from 'util/apiErrorNotification'
import { STORAGE_ITEM } from '../../../types/enum'
const { Search } = Input

function fetchAccountManager () {
  const cachedData = fetchAccountManager.cache
  const promise = cachedData
    ? Promise.resolve({
      code: 0,
      info: 'success',
      data: cachedData,
    })
    : axios.post(`${BD_API}/seller/customer/base-info/query-manager`, {})

  return promise
    .then(({ code, info, data }) => {
      if (code) throw Error(info)
      fetchAccountManager.cache = data
      return data
    })
    .catch(apiErrorNotification)
}

fetchAccountManager.cache = undefined

export { fetchAccountManager }

interface PropsType {
  userInfo: UserInfo | undefined
  changeStatusAndFlag: () => void
}

interface InitAccountManager {
  imgUrl: string
  name: string
  email: string
  copywritingEn: string
}

export default function CustomerManageModal (props: PropsType) {
  const energys = [
    'Listen to all your requests',
    'Provide suggestions for your store and operation',
    'Provide e-commerce solutions',
    'Help you use BuckyDrop easily and efficiently',
  ]

  const { userInfo, changeStatusAndFlag } = props

  const [accountManager, setAccountManager] = useState({} as InitAccountManager)

  const showConversationTip = () => {
    const BeijingHours = (new Date().getUTCHours() + 8) % 24
    return BeijingHours > 8 && BeijingHours < 18
      ? 'Our staff will reply you instantly after you connect to our online customer service system.'
      : 'Our customer service is available from Mon to Sun, 9:00 - 18:00 (Beijing Time). You may leave a message here, we will reply you within 24 hours.'
  }

  const search = value => {
    if (!value) {
      notification.warn({
        message: 'The search content cannot be empty',
      })
    } else {
      window.open(`/en/help/?s=${encodeURIComponent(value)}`)
    }
  }

  const findAccountManager = () => {
    // 如果没有登录，不需要查找专属客服
    if (!userInfo) {
      return
    }

    fetchAccountManager().then(data => setAccountManager(data.data ? data.data : data))
  }

  const onLineService = () => {
    const clientW: number = window.screen.availWidth || window.screen.width || 1280
    const clientH: number = window.screen.availHeight || window.screen.height || 800
    const height: number = 600
    const width: number = 900
    const left: number = Math.floor((clientW - width) / 2)
    const top: number = Math.floor((clientH - height) / 2)
    const newWindow = window.open('', '',
      `height=${height}, width=${width}, left=${left}, top=${top} ,toolbar=no, menubar=no, location=no, status=no`) as Window

    if (userInfo) {
      axios
        .post(`${BD_API}/seller/echat/metaData`)
        .then(res => {
          if (res.code === 0 || res.data.code === 0) {
            newWindow.location.href = `${ONLINE_SERVICE_PATH}?companyId=12635&echatTag=new_website&lan=en&metaData=${res.data.metaData || res.data.data.metaData}`
          } else if (res.code === 10008 || res.data.code === 10008) {
            window.location.href = `${window.location.origin}/en/login/?ref=${encodeURIComponent(
              window.location.href,
            )}`
          } else {
            throw Error(`${res.info || res.data.info} [${res.code || res.data.code}]`)
          }
        })
        .catch(apiErrorNotification)
    } else {
      newWindow.location.href = `${ONLINE_SERVICE_PATH}?companyId=12635&echatTag=new_website&lan=en`
    }
  }

  useEffect(() => {
    window.sessionStorage.getItem(STORAGE_ITEM.TAG_POINT) === 'true' &&
    window.location.pathname.indexOf('manager') < 0 &&
    window.sessionStorage.setItem(STORAGE_ITEM.TAG_POINT, '')
    findAccountManager()
  })

  return (
    <div className='bubble'>
      <div className='cardContent'>
        <div className='cardTitle'>
          <p className='cardTitle_title'>Hi&nbsp;
            {
              userInfo
                ? userInfo.firstName || userInfo.customerEmail
                : 'there'
            }!
          </p>
          <div className='cardTitle_desc'>
              We make thousands of people own their dropshipping business
              easily, We are always here for you.
          </div>
        </div>
        <div className='card card1'>
          <p className='title-content'>Start a conversation</p>
          <p className='title-desc'>Our staff will reply you instantly.</p>
          <div>
            <span>{showConversationTip}</span>
          </div>
          <a
            className='chatButton'
            onClick={onLineService}
          >
            <span />
              New Conversation
          </a>
        </div>
        <div className='card'>
          <p className='title-content'>{accountManager.name
            ? 'Your Personal Account Manager'
            : 'Free Account Manager For You'}
          </p>
          {
            accountManager.name &&
              <div className='imgAndName'>
                <span className='imgAndName_imgBox'>
                  <img className='imgAndName_img' src={accountManager.imgUrl} />
                </span>
                <span className='imgAndName_name'>{accountManager.name}</span>
              </div>
          }
          {
            accountManager.name
              ? <div className='imgAndName_desc'>{accountManager.copywritingEn}</div>
              : (
                <ul className='contactList'>
                  {energys.map((item, index) => (
                    <li className='contactList_list' key={index}>
                      <span className='img-span' />
                      {item}
                    </li>
                  ))}
                </ul>
              )
          }
          <a
            className='enquireButton'
            href={`mailto:${accountManager.name
              ? accountManager.email
              : 'support@buckydrop.com'}`}
          >
            <span />
              Contact
          </a>
        </div>
        <div className='card'>
          <p className='title-content'>Find an answer yourself</p>
          <Search
            className='toSearch'
            placeholder='Input your question...'
            enterButton='Search'
            onSearch={value => search(value)}
          />
        </div>
      </div>
      <a
        onClick={changeStatusAndFlag}
        className='online-service-close'
      />
    </div>
  )
}
